import { Form, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import type { CatalogRow } from 'src/motornet/types';
import { formatDate } from 'src/utils';
import toaster from 'src/utils/toaster';
import { useSetMatrixAutoRenew } from './api';

const MatrixAutoRenewSwitch = ({ row }: { row: CatalogRow }) => {
	const { t, i18n } = useTranslation();
	const mutation = useSetMatrixAutoRenew();
	const current = row.matrixAutoRenew;
	const label = t('vehicle_association_matrix_auto_renew', { defaultValue: 'Rinnovo auto' });

	const toggle = (enabled: boolean) =>
		mutation.mutate(
			{ versionKey: row.versionKey, snapshot: row.snapshot, enabled },
			{
				onSuccess: () =>
					toaster.success(
						enabled
							? t('vehicle_association_matrix_auto_renew_on', { defaultValue: 'Rinnovo automatico matrice attivato' })
							: t('vehicle_association_matrix_auto_renew_off', { defaultValue: 'Rinnovo automatico matrice disattivato' })
					),
				onError: (err: Error) =>
					toaster.error(
						err.message ||
							t('vehicle_association_save_error', { defaultValue: "Errore nel salvataggio dell'associazione" })
					),
			}
		);

	return (
		<div
			onClick={(event) => event.stopPropagation()}
			title={
				current
					? t('vehicle_association_matrix_auto_renew_by', {
							user: current.by,
							date: formatDate(current.at, i18n.language, true),
							defaultValue: 'Modificato da {{user}} il {{date}}',
					  })
					: undefined
			}
		>
			{mutation.isPending ? (
				<Spinner animation="border" size="sm" role="status" aria-label={label} />
			) : (
				<Form.Check
					type="switch"
					id={`matrix-auto-renew-${row.versionKey}`}
					aria-label={label}
					checked={current?.enabled ?? false}
					onChange={(event) => toggle(event.target.checked)}
				/>
			)}
		</div>
	);
};

export default MatrixAutoRenewSwitch;
